<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body, html {
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Helvetica Neue', 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #555555;
}
h1, h2, h3, h4, h5, h6 {
  font-weight: 600;
  line-height: 1.4;
}
a {
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}
.container {
  width: 1140px;
  padding: 0;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue